import React, { useState } from 'react';
import { Paper, Tab, Tabs } from '@material-ui/core';

import { TabPanel } from 'shared';

import { BulkCreatePackagingPO } from './bulkCreatePackagingPO';
import { CreatePackagingPO } from './createPurchaseOrder';
import { ViewPackagingPO } from './viewPurchaseOrder';

function PackagingPurchaseOrder({ baseUrl }) {
    const [selectedTab, setSelectedTab] = useState('0');
    const handleChange = (event, value) => {
        setSelectedTab(value);
    };

    return (
        <Paper>
            <Tabs onChange={handleChange} value={selectedTab} indicatorColor="primary" textColor="primary" centered>
                <Tab id="ViewPurchaseOrders_Tab" label="View Purchase Orders" value="0" />
                <Tab id="CreatePurchaseOrder_Tab" label="Create Purchase Order" value="1" />
                <Tab id="BulkCreate_Tab" label="Bulk Create" value="2" />
            </Tabs>
            <TabPanel selectedTab={selectedTab} index="0">
                <ViewPackagingPO />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="1">
                <CreatePackagingPO />
            </TabPanel>
            <TabPanel selectedTab={selectedTab} index="2">
                <BulkCreatePackagingPO />
            </TabPanel>
        </Paper>
    );
}

export { PackagingPurchaseOrder };
